import Head from 'next/head'
import { fetchGetAdsByCompany, fetchGetBanners, fetchGetAdsFilterModelByBrandList, fetchGetCompanySiteSettings } from '../../../services/api'
import SingleBanner from '../../components/default/single-banner'
import Footer from '../../components/layout/footer'
import Header from '../../components/layout/header'
import StockInventoryListing from '../../components/stock/inventory-listing'

export default function StockPage({ companyGeneralData, banner, ads, models }) {
    companyGeneralData = JSON.parse(companyGeneralData);

    return (
        <>
            <Head>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="description" content="Conheça os carros blindados disponíveis no estoque. São diversos tipos de carros." />
                <meta name="author" content="https://bndv.com.br" />
                <title>{`${(companyGeneralData.company.nickName).toUpperCase()} - ${companyGeneralData.company.city ? companyGeneralData.company.city : ''} - Blindados`}</title>
            </Head>

            <div className="main-wrapper">
                <Header company={companyGeneralData.company} />
                {banner ? <SingleBanner imageUrl={banner.imageUrl} /> : null}
                <StockInventoryListing ads={ads} pageSize={18} models={models} />
                <Footer company={companyGeneralData.company} />
            </div>
        </>
    )
}

export async function getServerSideProps({ query }) {
    const siteSettings = await fetchGetCompanySiteSettings();
    const banners = await fetchGetBanners({ idMenuOption: 5 });
    const ads = await fetchGetAdsByCompany({
        pagination: { pageSize: 18, page: query.pag ?? 0 },
        filters: {
            brands: query.marca ?? '',
            models: query.modelo ?? '',
            years: query.ano ?? '',
            transmissions: query.cambio ?? '',
            fuels: query.combustivel ?? '',
            price_from: query.preco_de ?? '',
            price_to: query.preco_ate ?? '',
            armored: '1',
            ...(siteSettings?.stockSortCode === 'FEATURED' && { featured: true })
        },
        orderBy: siteSettings?.stockSortCode === 'FEATURED' ? 'BRAND_AND_MODEL' : query.ordem || siteSettings?.stockSortCode || 'BRAND_AND_MODEL'
    });
    const models = await fetchGetAdsFilterModelByBrandList({ brands: query.marca ? query.marca.split('|') : null });
    return {
        props: {
            banner: (banners && banners.length > 0) ? banners[0].banner : null,
            ads,
            models
        }
    }
}